// src/data/TEAMS.js
export const TEAMS = [
  // Seoul
  {
    id: 'YSeagles',
    name: '연세대 이글스',
    logo: '/assets/images/svg/teams/Yonsei.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'SNgreenterrors',
    name: '서울대 그린테러스',
    logo: '/assets/images/svg/teams/SNU.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'HYlions',
    name: '한양대 라이온스',
    logo: '/assets/images/svg/teams/Hanyang.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'KMrazorbacks',
    name: '국민대 레이저백스',
    logo: '/assets/images/svg/teams/Kookmin.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'UScityhawks',
    name: '서울시립대 시티혹스',
    logo: '/assets/images/svg/teams/UOS.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'HFblackKnights',
    name: '한국외대 블랙나이츠',
    logo: '/assets/images/svg/teams/HUFS.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'KKragingbulls',
    name: '건국대 레이징불스',
    logo: '/assets/images/svg/teams/Konkuk.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'HIcowboys',
    name: '홍익대 카우보이스',
    logo: '/assets/images/svg/teams/Hongik.png',
    region: 'Seoul',
    division:'1부',
  },
  {
    id: 'KUtigers',
    name: '고려대 타이거스',
    logo: '/assets/images/svg/teams/KoreaUniversity.png',
    region: 'Seoul',
    division:'2부',
  },
  {
    id: 'DongkukTuskers',
    name: '동국대 터스커스',
    logo: '/assets/images/svg/teams/Dongguk.png',
    region: 'Seoul',
    division:'2부',
  },
  {
    id: 'SScrusaders',
    name: '숭실대 크루세이더스',
    logo: '/assets/images/svg/teams/Soongsil.png',
    region: 'Seoul',
    division:'2부',
  },
  {
    id: 'CAbluedragons',
    name: '중앙대 블루드래곤스',
    logo: '/assets/images/svg/teams/ChungAng.png',
    region: 'Seoul',
    division:'2부',
  },
  {
    id: 'KHcommanders',
    name: '경희대 커맨더스',
    logo: '/assets/images/svg/teams/Kyunghee.png',
    region: 'Seoul',
    division:'2부',
  },
  {
    id: 'SGalbatross',
    name: '서강대 알바트로스',
    logo: '/assets/images/svg/teams/Sogang.png',
    region: 'Seoul',
    division:'2부',
  },

  // Gyeonggi-Gangwona
  {
    id: 'SKroyals',
    name: '성균관대 로얄스',
    logo: '/assets/images/svg/teams/SKKU.png',
    region: 'Gyeonggi-Gangwon',
    division:'1부',
  },
  {
    id: 'KWcapra',
    name: '강원대 카프라',
    logo: '/assets/images/svg/teams/Kangwon.png',
    region: 'Gyeonggi-Gangwon',
    division:'1부',
  },
  {
    id: 'DKkodiakbears',
    name: '단국대 코디악베어스',
    logo: '/assets/images/svg/teams/Dankook.png',
    region: 'Gyeonggi-Gangwon',
    division:'1부',
  },
  {
    id: 'YIwhitetigers',
    name: '용인대 화이트타이거스',
    logo: '/assets/images/svg/teams/YIU.png',
    region: 'Gyeonggi-Gangwon',
    division:'2부',
  },
  {
    id: 'IHtealdragons',
    name: '인하대 틸 드래곤스',
    logo: '/assets/images/svg/teams/Inha.png',
    region: 'Gyeonggi-Gangwon',
    division:'1부',
  },
  {
    id: 'HLphoenix',
    name: '한림대 피닉스',
    logo: '/assets/images/svg/teams/Hallym.png',
    region: 'Gyeonggi-Gangwon',
    division:'2부',
  },
  {
    id: 'HSkillerwhales',
    name: '한신대 킬러웨일스',
    logo: '/assets/images/svg/teams/Hanshin.png',
    region: 'Gyeonggi-Gangwon',
    division:'2부',
  },
  {
    id: 'KAmavericks',
    name: '카이스트 매버릭스',
    logo: '/assets/images/svg/teams/KAmavericks.png',
    region: 'Gyeonggi-Gangwon',
    division:'2부',
  },

  // Daegu-Gyeongbuk
  {
    id: 'KPorangefighters',
    name: '경북대 오렌지파이터스',
    logo: '/assets/images/svg/teams/KNU.png',
    region: 'Daegu-Gyeongbuk',
    division:'1부',
  },
  {
    id: 'KIblackbears',
    name: '경일대 블랙베어스',
    logo: '/assets/images/svg/teams/KIU.png',
    region: 'Daegu-Gyeongbuk',
    division:'1부',
  },
  {
    id: 'KeimyungSuperlions',
    name: '계명대 슈퍼라이온스',
    logo: '/assets/images/svg/teams/Keimyung.png',
    region: 'Daegu-Gyeongbuk',
    division:'2부',
  },
  {
    id: 'KOTravens',
    name: '금오공과대 레이븐스',
    logo: '/assets/images/svg/teams/Kumho.png',
    region: 'Daegu-Gyeongbuk',
    division:'2부',
  },
  {
    id: 'DCscudangels',
    name: '대구가톨릭대 스커드엔젤스',
    logo: '/assets/images/svg/teams/DaeguCatholic.png',
    region: 'Daegu-Gyeongbuk',
    division:'1부',
  },
  {
    id: 'DGflyingyigers',
    name: '대구대 플라잉타이거스',
    logo: '/assets/images/svg/teams/Daegu.png',
    region: 'Daegu-Gyeongbuk',
    division:'2부',
  },
  {
    id: 'DHrhinos',
    name: '대구한의대 라이노스',
    logo: '/assets/images/svg/teams/DaeguHaany.png',
    region: 'Daegu-Gyeongbuk',
    division:'1부',
  },
  {
    id: 'DongkukWhiteelephants',
    name: '동국대 화이트엘리펀츠',
    logo: '/assets/images/svg/teams/DaeguDongguk.png',
    region: 'Daegu-Gyeongbuk',
    division:'2부',
  },
  {
    id: 'YNpegasus',
    name: '영남대 페가수스',
    logo: '/assets/images/svg/teams/Yeungnam.png',
    region: 'Daegu-Gyeongbuk',
    division:'2부',
  },
  {
    id: 'HDholyrams',
    name: '한동대 홀리램스',
    logo: '/assets/images/svg/teams/Handong.png',
    region: 'Daegu-Gyeongbuk',
    division:'1부',
  },

  // Busan-Gyeongnam
  {
    id: 'GSdragons',
    name: '경성대 드래곤스',
    logo: '/assets/images/svg/teams/Kyungsung.png',
    region: 'Busan-Gyeongnam',
    division:'1부',
  },
  {
    id: 'BSeagles',
    name: '부산대 이글스',
    logo: '/assets/images/svg/teams/Pusan.png',
    region: 'Busan-Gyeongnam',
    division:'2부',
  },
  {
    id: 'HHvikings',
    name: '한국해양대 바이킹스',
    logo: '/assets/images/svg/teams/KMOU.png',
    region: 'Busan-Gyeongnam',
    division:'2부',
  },
  {
    id: 'SLdevils',
    name: '신라대 데빌스',
    logo: '/assets/images/svg/teams/Silla.png',
    region: 'Busan-Gyeongnam',
    division:'2부',
  },
  {
    id: 'BKmadmobydicks',
    name: '부경대 매드모비딕스',
    logo: '/assets/images/svg/teams/BKmadmobydicks.png',
    region: 'Busan-Gyeongnam',
  },
  {
    id: 'DUturtlefighters',
    name: '동의대 터틀파이터스',
    logo: '/assets/images/svg/teams/Dongeui.png',
    region: 'Busan-Gyeongnam',
    division:'1부',
  },
  {
    id: 'DAleopards',
    name: '동아대 레오파즈',
    logo: '/assets/images/svg/teams/Dong-A.png',
    region: 'Busan-Gyeongnam',
    division:'1부',
  },
  {
    id: 'DSbluedolphins',
    name: '동서대 블루돌핀스',
    logo: '/assets/images/svg/teams/Dongseo.png',
    region: 'Busan-Gyeongnam',
    division:'2부',
  },
  {
    id: 'BFtornado',
    name: '부산외국어대 토네이도',
    logo: '/assets/images/svg/teams/BUFS.png',
    region: 'Busan-Gyeongnam',
    division:'2부',
  },
  {
    id: 'UUunicorns',
    name: '울산대 유니콘스',
    logo: '/assets/images/svg/teams/Ulsan.png',
    region: 'Busan-Gyeongnam',
    division:'1부',
  },

  // Amateur
  {
    id: 'GunwiPhoenix',
    name: '군위 피닉스',
    logo: '/assets/images/svg/teams/Phoenix.png',
    region: 'Amateur',
  },
  {
    id: 'BusanGryphons',
    name: '부산 그리폰즈',
    logo: '/assets/images/svg/teams/Gryphons.png',
    region: 'Amateur',
  },
  {
    id: 'samsungBT',
    name: '삼성 블루스톰',
    logo: '/assets/images/svg/teams/BlueStorm.png',
    region: 'Amateur',
  },
  {
    id: 'seoulGE',
    name: '서울 골든이글스',
    logo: '/assets/images/svg/teams/GoldenEagles.png',
    region: 'Amateur',
  },
  {
    id: 'seoulDF',
    name: '서울 디펜더스',
    logo: '/assets/images/svg/teams/Defenders.png',
    region: 'Amateur',
  },
  {
    id: 'seoulVI',
    name: '서울 바이킹스',
    logo: '/assets/images/svg/teams/Vikings.png',
    region: 'Amateur',
  },
  {
    id: 'IncheonRH',
    name: '인천 라이노스',
    logo: '/assets/images/svg/teams/Rhinos.png',
    region: 'Amateur',
  },

  // Admin 팀
  {
    id: 'ADMIN',
    name: '관리자',
    logo: '/assets/images/svg/teams/Stechlogo.svg',
    region: 'Admin', 
  },
  {
    id: 'GC',
    name: '경기강원올스타',
    logo: '/assets/images/svg/teams/gcf.png',
    region: 'Gyeonggi-Gangwon',
  },
];

export const GUEST_TEAMS = [
  {
    id: 'seoulVI',
    name: '서울 바이킹스',
    logo: '/assets/images/svg/teams/Vikings.png',
    region: 'Amateur',
  },

  //경기강원협회 /게스트용
  {
    id: 'GC',
    name: '경기강원올스타',
    logo: '/assets/images/svg/teams/gcf.png',
    region: 'Gyeonggi-Gangwon',
  },
];

export const TEAM_BY_ID = Object.fromEntries(TEAMS.map((t) => [t.id, t]));
export const TEAM_BY_NAME = Object.fromEntries(TEAMS.map((t) => [t.name, t]));
